import RangeController from "../controllers/range_controller";

export default class extends RangeController {
    dispatchChangeEvent() {
        super.dispatchChangeEvent();
        if (this.hasYearsTextTarget && this.typeValue === 'Years') {
            const value = this.maxInputTarget.value
            let yearText = ""
            if (value == 1){
                yearText = "Up to 1 Year"
            } else if ( value == 8){
                yearText = "8+ Years"
            } else{
                yearText = `Up to ${value} Years`
            }
            this.yearsTextTarget.textContent = yearText;
        }
    }

    initializeHandleInputs() {
        const initialMax = this.maxInputTarget.value;

        this.updateHandleFromInput(this.minInputTarget.value, this.minRange, this.maxRange, this.minHandleTarget);
        this.updateHandleFromInput(initialMax, this.minRange, this.maxRange, this.maxHandleTarget);
    }

    resetSlider() {
        this.maxInputTarget.value = null;
        this.updateHandleFromInput(null, this.minRange, this.maxRange, this.maxHandleTarget);
        this.updateTrackFill();
        this.dispatchChangeEvent();
        
        if (this.hasClearButtonTarget) {
            this.clearButtonTarget.classList.add('hidden');
        }
    }
}